import {Button} from '@wandb/weave/components/Button';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React, {useState} from 'react';
import {Popup} from 'semantic-ui-react';

import {trackSetting} from '../../services/analytics/workspaceSettingsEvents';
import {
  LinePlotSmoothing,
  type LinePlotSmoothingProps,
} from '../WorkspaceDrawer/Settings/runLinePlots/LinePlotSmoothing';

export const SmoothingSetting = (
  props: LinePlotSmoothingProps & {
    isActive: boolean;
  }
) => {
  const {isActive, settingLevel} = props;
  const [popupType, setPopupType] = useState<'label' | 'options'>();

  return (
    <Popup
      on="click"
      position={settingLevel === 'report' ? 'bottom left' : 'bottom right'}
      onOpen={() => {
        setPopupType('options');
        trackSetting({
          action: 'open popup',
          page: settingLevel === 'report' ? 'report' : 'workspace',
          settingLevel,
          setting: 'smoothing',
        });
      }}
      onClose={() => setPopupType(undefined)}
      trigger={
        <Button
          active={isActive}
          icon="smoothing"
          variant={settingLevel === 'report' ? 'secondary' : 'ghost'}
          aria-label="Smoothing settings"
          tooltip={!popupType ? 'Smoothing settings' : ''}
          tooltipProps={{
            align: 'center',
            side: 'bottom',
          }}
        />
      }
      content={
        <TailwindContents>
          <div className="w-[27rem]">
            <LinePlotSmoothing {...props} />
          </div>
        </TailwindContents>
      }
    />
  );
};
